var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.629 3.5065C7.68483 1.61317 8.21233 0.666504 9.0015 0.666504C9.79066 0.666504 10.3182 1.61317 11.374 3.5065L11.6473 3.9965C11.9473 4.53484 12.0973 4.804 12.3307 4.9815C12.564 5.159 12.8557 5.22484 13.439 5.3565L13.969 5.4765C16.019 5.94067 17.0432 6.17234 17.2873 6.9565C17.5307 7.73984 16.8323 8.55734 15.4348 10.1915L15.0732 10.614C14.6765 11.0782 14.4773 11.3107 14.3882 11.5973C14.299 11.8848 14.329 12.1948 14.389 12.814L14.444 13.3782C14.6548 15.559 14.7607 16.649 14.1223 17.1332C13.484 17.6173 12.524 17.1757 10.6057 16.2923L10.1082 16.064C9.56316 15.8123 9.29066 15.6873 9.0015 15.6873C8.71233 15.6873 8.43983 15.8123 7.89483 16.064L7.39816 16.2923C5.479 17.1757 4.519 17.6173 3.8815 17.134C3.24233 16.649 3.34816 15.559 3.559 13.3782L3.614 12.8148C3.674 12.1948 3.704 11.8848 3.614 11.5982C3.52566 11.3107 3.3265 11.0782 2.92983 10.6148L2.56816 10.1915C1.17066 8.55817 0.472331 7.74067 0.715665 6.9565C0.958998 6.17234 1.98483 5.93984 4.03483 5.4765L4.56483 5.3565C5.14733 5.22484 5.43816 5.159 5.67233 4.9815C5.9065 4.804 6.05566 4.53484 6.35566 3.9965L6.629 3.5065Z",
    stroke: "#DCDCEC",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyFeatures);
export default __webpack_public_path__ + "static/media/key_features.34eb0145bbb0c070fd12a870416bb621.svg";
export { ForwardRef as ReactComponent };